<template>
    <BCard no-body>
        <BCardBody class="d-flex justify-content-between">
            <div>
                <BCardTitle>Clases</BCardTitle>
                <BCardSubTitle>Listado de clases programadas</BCardSubTitle>
            </div>
            <!-- <div>
                <BFormInput v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search') + '...'" />
            </div> -->
            <div>
                <BDropdown
                id="dropdown-3"
                text="Exportar"
                variant="success"
                class="mr-1"
                >
                    <BDropdownItem @click="exportData('/lessons/export', { id: course.id, type: 'PDF' }, `Clases ${course.name}.pdf`, 'PDF')">PDF</BDropdownItem>
                    <BDropdownItem @click="exportData('/lessons/export', { id: course.id, type: 'CSV' }, `Clases ${course.name}.csv`, 'CSV')">CSV</BDropdownItem>
                    <BDropdownItem @click="exportData('/lessons/export', { id: course.id, type: 'XLS' }, `Clases ${course.name}.xls`, 'XLS')">XLS</BDropdownItem>
                </BDropdown>
            </div>
        </BCardBody>
        <BTable id="lessonsTable" striped :items="lessons" :per-page="perPage" :current-page="currentPage" :fields="fields" show-empty empty-text="Ninguna clase programada">
          <template #cell(datetime)="data">
            <small>
                <span class="text-nowrap text-center"><b>{{ formatDate(data.item.start_date)}}</b></span><br>
                <BLink :to="{ name: 'lessons-view', params: { id: data.item.id} }"><span class="text-nowrap text-center">{{ data.item.start_time }} - {{ data.item.end_time }}</span></BLink>
            </small>
          </template>
          <template #cell(teacher)="data" v-if="ability.can('read', 'teacher')">
            <BLink v-if="data.item.teacher" :to="{ name: 'teachers-view', params: { id: data.item.teacher.id} }" >{{ data.item.teacher.name + " " + data.item.teacher.surname }} <br> </BLink>
            <span v-else>-</span>
          </template>

          <template #cell(teacher)="data" v-else>
            <span> {{ data.item.teacher.name + " " + data.item.teacher.surname }} <br> </span>
          </template>

          <template #cell(course)="data" v-if="ability.can('read', 'course')">
            <BLink :to="{ name: 'courses-view', params: { id: data.item.course.id} }">{{ data.item.course.name }} <br> </BLink>
          </template>

          <template #cell(course)="data" v-else>
            <span> {{ data.item.course.name }} <br> </span>
          </template>

          <template #cell(is_extra)="data">
            <BFormCheckbox id="checkbox-paid" v-model="data.item.is_extra" disabled ></BFormCheckbox> <span v-if="data.item.is_extra"> {{ formatCurrency(data.item.amount) }}</span>
          </template>

          <template #cell(paid_lessons)="data">
            <span v-if="data.item.is_extra"> {{ data.item.already_paid.paid + "/" + data.item.already_paid.total}} <br> </span>
            <span v-else>-</span>
          </template>

          <template #cell(observations)="data">
            <span>{{ data.item.observations ? data.item.observations : '-'  }}</span>
          </template>
        </BTable>
        <BPagination class="m-2" v-model="currentPage" :total-rows="lessons.length" :per-page="perPage" aria-controls="lessonsTable"></BPagination>
    </BCard>
</template>

<script>
import { inject, ref, watch } from '@vue/composition-api';
import axios from '@axios';
import { BCard, BCardBody, BCardSubTitle, BCardTitle, BDropdown, BDropdownItem, BFormInput, BPagination, BTable, BLink, BFormCheckbox } from 'bootstrap-vue';
import exportUtils from '@/hooks/exportUtils';
import ability from '@/libs/acl/ability'
import dateUtils from '@/hooks/dateUtils'
import currency from '@/utils/currency'
import { existsModule } from '@/hooks/modulesUtils';

export default {
    components: { BTable, BPagination, BCard, BCardBody, BCardTitle, BCardSubTitle, BFormInput, BDropdown, BDropdownItem, BLink, BFormCheckbox },
    setup() {
        const { exportData } = exportUtils()
        const course = inject('course')
        const lessons = ref([])
        const { formatDate } = dateUtils()  
        const { formatCurrency } = currency()
        const currentPage = ref(1)
        const searchQuery = ref("")
        const perPage = ref(10)
        const fields = ref([
            { key: 'datetime', label: 'Fecha y hora', sortable: true },
            { key: 'is_extra', label: 'Clase extra' },
            { key: 'paid_lessons', label: 'Cobradas'},
            { key: 'observations', label: 'Observaciones'},
        ])
        
        if (existsModule('Academy')) fields.value.push({ key: 'teacher', label: 'Profesor/a', sortable: true }) 

        const query = ref({
          course: course.value.id
        })

        const fetchCourseLessons = function() {
            axios.get('/lessons', { params: query.value }).then(response => {
              console.log(response)
                lessons.value = response.data.lessons
                console.log(lessons.value)
            })
        }

        
        fetchCourseLessons()

        watch(course, val => {
          query.value.course=course.value.id
          fetchCourseLessons()
        })

        return {
            exportData,
            searchQuery,
            lessons,
            currentPage,
            perPage,
            fields,
            course,
            ability,
            formatCurrency, 
            formatDate
        };
    },
}
</script>
